import { render } from "./OrderEmailReceiptModal.vue?vue&type=template&id=6bb8f6fe"
import script from "./OrderEmailReceiptModal.vue?vue&type=script&lang=js"
export * from "./OrderEmailReceiptModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__